/**
 * Defers callback execution until after the next frame has been painted.
 * Uses double requestAnimationFrame to ensure skeleton loaders display before data loads.
 */
export function deferAfterRender(callback: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback)
  })
}
